import VideoService from '@/services/VideoService'

const state = {
  data: []
}

const mutations = {
  SET_DATA (state, data) {
    state.data = data
  }
}

const actions = {
  async index ({ commit }) {
    const data = await VideoService.index()
    commit('SET_DATA', data)
    return data
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
